Prelogin = (function (prelogin) {
    prelogin.EasyLogin = {};
    const me = prelogin.EasyLogin;
    // eslint-disable-next-line no-unused-vars
    let refreshTimer = null;

    me.init = function () {
        if ($('.easy-login-form').length) {
            $('#easy-login-code').on('click', function () {
                if (this.value.length === +$(this).attr('maxlength')) {
                    $(this).parent().next().focus();
                }
            });
        }

        if ($('.easy-login-student-list').length) {
            refreshTimer = setInterval(() => {
                $.get('', (data) => {
                    $('#student-list-container').html(DOMPurify.sanitize(data));
                }).fail(() => {
                    window.location.replace('/');
                });
            }, 5000);
        }
    };

    return prelogin;
}(Prelogin || {}));
